import axios from 'axios'
import { BACKEND_API } from './apiConfig'
import { store } from '../store/index'
import { logout } from '../store/slices/AuthSlice'

const lang = localStorage.getItem('i18nextLng')
const sub = localStorage.getItem('sub')

const validSupergitHIS = axios.create({
  baseURL: BACKEND_API,
  headers: {
    Accept: `application/json`,
    'Accept-Language': `${lang}`,
    'x-sub': sub,
    'current-version': '3.3.1'
  },
})

validSupergitHIS.interceptors.request.use(
  config => {
    const state = store.getState()
    const token = state.auth.token

    const lang = localStorage.getItem('i18nextLng') || 'en'
    config.headers['Accept-Language'] = lang

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

validSupergitHIS.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response && error.response.status === 401) {
      store.dispatch(logout())
    }
    return Promise.reject(error)
  }
)

export default validSupergitHIS
